module.exports = __webpack_public_path__ + "img/3e9113b.png";